import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as A from '../store/lineageActions';
import LineageEditorShell from './LineageEditorShell';
import '../../../styles/components/data-lineage/lineage-editor.scss';

class LineageEditor extends Component {
  componentDidMount() {
    this.props.loadMap(this.props.mapId);
  }

  componentDidUpdate(prev) {
    if (prev.mapId !== this.props.mapId) {
      this.props.loadMap(this.props.mapId);
    }
  }

  render() {
    return <LineageEditorShell onBack={this.props.onBack} />;
  }
}

export default connect(null, {loadMap: A.loadMap})(LineageEditor);
